/*
 * @Date: 2022-08-15 14:59:27
 * @LastEditTime: 2022-10-06 15:47:15
 * @Description:
 */
import { net_collection } from "@/api/http";
export const API_DisplaySelectBopUserScreen = (...params) =>
  net_collection.post("/api/STDSDC03C03/DisplaySelectBopUserScreen", ...params);

export const API_GetTaxFileBusinessOperatorType = (...params) =>
  net_collection.post(
    "/api/STDSDC03C03/GetTaxFileBusinessOperatorType",
    ...params
  );
